import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getDailyQuizs = async (data) => {
  return decryptData(
    await axios.get(
      `/dailyquiz/list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addDailyQuiz = async (data) => {
  return decryptData(
    await axios.post(`/dailyquiz/create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getSingleDailyQuizById = async (data) => {
  return decryptData(
    await axios.get(
      `/dailyquiz/details?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const deleteDailyQuiz = async (data) => {
  return decryptData(
    await axios.get(
      `/dailyquiz/delete?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
